import { el } from "./dom";

// A pick list's link to where the company changes it (brief 1E-25; DECISIONS 10/30 "Every pick list
// is a company list"): Settings › Lists, opened on that list.
export const listLink = (key: string, words = "Change the list") =>
  el(
    "a",
    { href: `/settings/lists?list=${encodeURIComponent(key)}`, class: "small", "data-list": key },
    words,
  );
